<brd-hero-image></brd-hero-image>
<brd-maintenance-alert></brd-maintenance-alert>
<div class="section-container">
  <div class="title">
    <span>Frequently asked questions (FAQs)</span>
  </div>
  <div class="faq-container">
    <mat-accordion class="module-accordion" [multi]="true" togglePosition="before" displayMode="flat">
      <mat-expansion-panel class="module-panel" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="module-title subtitle"> Where do I find information about a Demo asset? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="image-container">
          <span>
            To find information about an individual demo simply click on the <b>INFO</b> icon of the demo. Here you can view all the
            information you need like the
            <b>description, modules, use cases, applicable industries, functionalities and enablement material links.</b>
          </span>
          <img src="assets/images/faq/Picture3.gif" alt="Picture3" height="300px" />
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel class="module-panel" [expanded]="false" *ngIf="faqInfo$ | async as faqInfo">
        <mat-expansion-panel-header>
          <mat-panel-title class="module-title subtitle"> Is a Demo Environment always available? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          Every Demo environment is
          <b>put in "sleep" mode after {{ faqInfo.sleepInstanceInterval }} hours (if not accessed by anyone).</b> When that happens,
          <b>it can be restarted by all users in the same User Group.</b>
        </p>
        <p>
          Every Demo environment is <b>deleted after {{ faqInfo.deleteInstanceInterval / 24 }} days of inactivity.</b>
        </p>
        <p>Each login resets the inactivity counter.</p>
        <p>Please note that no automatic backup is performed on demo portal cloud machines.</p>
        <p>
          If you wish to retain the material created or customized in a demo environment, please open a ticket and request the cloud/support
          team to download the specific application, which you can then share or re-use freely
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel class="module-panel" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="module-title subtitle"> How do I login into the Demo Environment? </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="faq-component">
          Once a demo environment is created, it is <b>accessible using the creator's email</b>, through the SSO enabled. In the
          <b>Subscription Hub</b> of the demo environment, <b>the creator can add more users</b> and assign licenses for access.
          <p class="image-container-center">
            <img src="assets/images/faq/Picture4.gif" alt="Picture4" height="300px" />
          </p>
          <p class="image-container-center">
            <span> The <b>Info window</b> also contains the user details required to <b>access the data pipeline</b>.</span>
            <img src="assets/images/faq/Picture7.png" alt="Picture7" height="300px" />
          </p>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel class="module-panel" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="module-title subtitle"> How do I backup or restore a database in a Demo Environment? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          The native backup/restore functionalities are linked to the C:\ drive instead of Z:\. To perform a backup or restore in Z:\, it is
          necessary to run a dedicated procedure where the path points to the Z:\ drive, not C:\.
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel class="module-panel" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="module-title subtitle"> Can I access the Admin Portal? Can I upload files? </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="image-container">
          <img src="assets/images/faq/Picture6.gif" alt="Picture6" height="300px" />
          <span>
            Once created, every new Demo Environment also includes the Cloud Admin Portal and a Shared Drive.
            <br /><br />
            You can access it through the info window of each Demo, with the same login credentials.
          </span>
        </p>
      </mat-expansion-panel>
      <!-- <mat-expansion-panel class="module-panel" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="module-title subtitle"> I have issues with the Demo Portal: what to do? </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="faq-component">
          <b>IF YOU ARE A BOARD EMPLOYEE</b>, and if:
          <ul>
            <li>
              you find an infrastructural issue with the Demo Portal or you have problem in accessing it, please open a ticket on
              Salesforce;
            </li>
            <li>
              you find any other sort of issues with the Demo Portal, please contact the support team
              <a href="mailto:demoportal@board.com">demoportal&#64;board.com</a>: we will help you in triaging the request.
            </li>
          </ul>
          <b>IF YOU ARE A PARTNER</b>, and if you find any sort of issues with the Demo Portal, please fill the following
          <a href="https://app.smartsheet.com/b/form/5434a65e18a44c5284c6526a31b25ee1" target="_blank">form</a>; your Partner Success
          Manager will help you in triaging the request by:
          <ul>
            <li>opening a Cloud ticket (on Salesforce) in case of <b>Cloud/Infrastructure Issue;</b></li>
            <li>
              sending an email to
              <a href="mailto:demoportal@board.com">demoportal&#64;board.com</a> with the Partner in CC and the Demo Portal Team in case of
              a
              <b>Demo Asset Issue, a Bug or an Idea.</b>
            </li>
          </ul>
        </div>
      </mat-expansion-panel> -->
    </mat-accordion>
  </div>
</div>
<brd-contact-support></brd-contact-support>
